export default function alwaysPristine() {
  return {
    restict: 'A',
    require: ['?ngModel', '?form'],
    link($scope, $element, $attrs, ctrls) {
      ctrls.forEach((ctrl) => {
        if (ctrl) {
          ctrl.$setDirty = () => {};
        }
      });
    },
  };
}
